import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['document', 'zoomOverlay']

  connect() {
    this.isZoomed = false
  }

  toggleZoom(event) {
    const img = event.currentTarget

    if (this.isZoomed) {
      this.closeZoom()
    } else {
      this.openZoom(img)
    }
  }

  openZoom(img) {
    // Create overlay
    const overlay = document.createElement('div')
    overlay.className = 'fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center cursor-zoom-out'
    overlay.setAttribute('data-admin--blood-test-review-target', 'zoomOverlay')

    // Create zoomed image
    const zoomedImg = document.createElement('img')
    zoomedImg.src = img.src
    zoomedImg.className = 'max-h-[90vh] max-w-[90vw] object-contain'

    // Close button
    const closeBtn = document.createElement('button')
    closeBtn.className = 'absolute top-4 right-4 text-white text-3xl font-bold hover:text-slate-300'
    closeBtn.innerHTML = '&times;'
    closeBtn.onclick = () => this.closeZoom()

    // Instructions
    const instructions = document.createElement('div')
    instructions.className = 'absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white text-sm'
    instructions.textContent = 'Click anywhere or press ESC to close'

    overlay.appendChild(zoomedImg)
    overlay.appendChild(closeBtn)
    overlay.appendChild(instructions)
    overlay.onclick = () => this.closeZoom()

    document.body.appendChild(overlay)
    document.body.style.overflow = 'hidden'

    // Handle ESC key
    this.escHandler = (e) => {
      if (e.key === 'Escape') this.closeZoom()
    }
    document.addEventListener('keydown', this.escHandler)

    this.isZoomed = true
  }

  closeZoom() {
    if (this.hasZoomOverlayTarget) {
      this.zoomOverlayTarget.remove()
    }

    // Also try to find by class in case target isn't registered
    const overlay = document.querySelector('[data-admin--blood-test-review-target="zoomOverlay"]')
    if (overlay) {
      overlay.remove()
    }

    document.body.style.overflow = ''

    if (this.escHandler) {
      document.removeEventListener('keydown', this.escHandler)
    }

    this.isZoomed = false
  }

  disconnect() {
    this.closeZoom()
  }
}
